export const contact = [
  {
    icon: "@",
    url: "mailto:vittorioretrivi@gmail.com",
    display: "vittorioretrivi@gmail.com",
  },
  {
    icon: "G",
    url: "https://github.com/motiontx",
    display: "github.com/motiontx",
  },
  {
    icon: "L",
    url: "https://www.linkedin.com/in/vittorio-retrivi",
    display: "linkedin.com/in/vittorio-retrivi",
  },
];
